(function () {
  'use strict';
 
  var CONFIG = {
    maxSorten: 3,
    // Reihenfolge wichtig: erste passende Regel gewinnt.
    // "test" wird gegen den Variantennamen (kleingeschrieben) geprüft.
    // normal = normaler Pflanzabstand, fast = schnellerer Sichtschutz.
    // Stand 01.09.2026: 9-cm-Topf 4/5 je Meter, 3-L-Topf 2/3 je Meter (Regel aus Pflanzwissen).
    potRules: [
      { test: /9\s*cm|9cm/,            normal: 4, fast: 5 },
      { test: /3\s*l|3l|3\s*liter/,    normal: 2, fast: 3 }
    ],
    defaultRule: { normal: 2, fast: 3 }, // Fallback, wenn kein Muster passt
    checkoutPath: '/cart'
  };
 
  /* ---------- Helfer ---------- */
  function heightCm(v) {
    // Wuchshöhe -> cm. Erkennt "3,5 m", "350 cm", "bis 3 m", "150-200".
    if (v === null || v === undefined) return null;
    if (typeof v === 'number') return v < 20 ? v * 100 : v; // 3.5 -> 350
    var s = String(v).toLowerCase();
    var nums = s.match(/\d+(?:[.,]\d+)?/g);
    if (!nums) return null;
    var max = Math.max.apply(null, nums.map(function (x) { return parseFloat(x.replace(',', '.')); }));
    if (s.indexOf('cm') !== -1) return max;
    if (/\dm|\sm|meter/.test(s)) return max * 100;
    return max < 20 ? max * 100 : max; // Heuristik: kleine Zahl = Meter
  }
  function money(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + '\u00a0€';
  }
  function plantsPerMeter(variantTitle, density) {
    var t = String(variantTitle || '').toLowerCase();
    var key = density === 'fast' ? 'fast' : 'normal';
    for (var i = 0; i < CONFIG.potRules.length; i++) {
      if (CONFIG.potRules[i].test.test(t)) return CONFIG.potRules[i][key];
    }
    return CONFIG.defaultRule[key];
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
 
  /* ---------- App ---------- */
  function init() {
    var dataEl = document.getElementById('hb-products');
    if (!dataEl) return;
    var products = [];
    try { products = JSON.parse(dataEl.textContent) || []; } catch (e) { products = []; }
 
    var root = document.getElementById('heckenberater-app');
    if (!root) {
      root = document.createElement('div');
      root.id = 'heckenberater-app';
      dataEl.parentNode.insertBefore(root, dataEl.nextSibling);
    }
    var collectionUrl = dataEl.getAttribute('data-collection-url') || '/collections/fargesia';
 
    var state = {
      selected: [],          // Array von product.handle
      laenge: '',            // Meter
      hoehe: '',             // Wunschhöhe cm
      dichte: 'normal',      // 'normal' | 'fast' (Pflanzdichte)
      variantByHandle: {}    // handle -> variant id (Auswahl)
    };
 
    function productByHandle(h) {
      for (var i = 0; i < products.length; i++) if (products[i].handle === h) return products[i];
      return null;
    }
 
    function render() {
      var laenge = parseFloat(String(state.laenge).replace(',', '.'));
      var hoehe = parseFloat(String(state.hoehe).replace(',', '.'));
 
      /* --- Schritt 1: Sorten --- */
      var sortenHtml = products.map(function (p) {
        var sel = state.selected.indexOf(p.handle) !== -1;
        var hooded = !p.available;
        var meta = [];
        var hc = heightCm(p.wuchshohe);
        if (p.wuchshohe) meta.push('bis ' + esc(p.wuchshohe));
        if (p.winterharte) meta.push(esc(p.winterharte));
        var fits = (isNaN(hoehe) || hc === null || hc >= hoehe);
        return '<div class="hb-sorte' + (sel ? ' selected' : '') + (hooded ? ' soldout' : '') + '" data-handle="' + esc(p.handle) + '"' +
          (fits ? '' : ' style="opacity:.45"') + '>' +
          '<div class="hb-sorte-img">' + (p.image ? '<img src="' + esc(p.image) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</div>' +
          '<div class="hb-sorte-info"><div class="hb-sorte-name">' + esc(p.title) + '</div>' +
          (meta.length ? '<div class="hb-sorte-meta">' + meta.join(' · ') + '</div>' : '') +
          (hooded ? '<div class="hb-sorte-soldtag">Ausverkauft</div>' : '') +
          (!fits ? '<div class="hb-sorte-meta">unter deiner Wunschhöhe</div>' : '') +
          '</div></div>';
      }).join('');
 
      /* --- Schritt 3: Variante je gewählter Sorte --- */
      var variantHtml = state.selected.map(function (h) {
        var p = productByHandle(h);
        if (!p) return '';
        var opts = p.variants.map(function (v) {
          var selId = state.variantByHandle[h];
          var chosen = selId ? String(selId) === String(v.id) : v.available;
          return '<option value="' + v.id + '"' + (chosen ? ' selected' : '') + (v.available ? '' : ' disabled') + '>' +
            esc(v.title) + ' – ' + money(v.price) + (v.available ? '' : ' (ausverkauft)') + '</option>';
        }).join('');
        return '<div class="hb-variant-row"><div class="hb-variant-name">' + esc(p.title) + '</div>' +
          '<select data-handle="' + esc(h) + '">' + opts + '</select></div>';
      }).join('');
 
      /* --- Berechnung --- */
      var resultHtml = '';
      var canCalc = state.selected.length > 0 && !isNaN(laenge) && laenge > 0;
      if (canCalc) {
        var share = laenge / state.selected.length;
        var rows = '';
        var totalPlants = 0, totalCost = 0, allChosen = true;
        state.selected.forEach(function (h) {
          var p = productByHandle(h);
          if (!p) return;
          var vid = state.variantByHandle[h];
          var v = null;
          for (var i = 0; i < p.variants.length; i++) {
            if (vid ? String(p.variants[i].id) === String(vid) : p.variants[i].available) { v = p.variants[i]; break; }
          }
          if (!v) { allChosen = false; return; }
          state.variantByHandle[h] = v.id;
          var ppm = plantsPerMeter(v.title, state.dichte);
          var qty = Math.max(1, Math.ceil(share * ppm));
          totalPlants += qty;
          totalCost += qty * v.price;
          rows += '<div class="hb-result-row"><span>' + esc(p.title) + ' (' + esc(v.title) + ', ' + ppm + '/m)</span>' +
            '<strong>' + qty + ' Stk. · ' + money(qty * v.price) + '</strong></div>';
        });
        if (allChosen) {
          var dichteLabel = state.dichte === 'fast' ? 'Schneller Sichtschutz' : 'Sichtschutz';
          resultHtml = '<div class="hb-result">' + rows +
            '<div class="hb-result-row"><span>Heckenlänge</span><strong>' + laenge.toString().replace('.', ',') + ' m</strong></div>' +
            '<div class="hb-result-row"><span>Pflanzdichte</span><strong>' + dichteLabel + '</strong></div>' +
            '<div class="hb-result-total"><span>Gesamt: ' + totalPlants + ' Pflanzen</span><span>' + money(totalCost) + '</span></div>' +
            '<div class="hb-note">Richtwerte: 3-L-Topf 2–3 Pflanzen/m, 9-cm-Topf 4–5 Pflanzen/m – je nach gewählter Dichte. Versandkostenfrei ab 100\u00a0€.</div>' +
            '</div><div class="hb-actions"><button class="hb-btn hb-btn-primary" id="hb-atc">Alles in den Warenkorb</button>' +
            '<div id="hb-msg"></div></div>';
        }
      } else {
        resultHtml = '<div class="hb-note">Wähle mindestens eine Sorte und gib die Heckenlänge ein – dann berechnen wir Stückzahl und Kosten.</div>';
      }
 
      root.innerHTML =
        '<div class="hb-card"><div class="hb-step-label">Schritt 1</div>' +
        '<div class="hb-step-title">Wähle deine Wunsch-Sorten</div>' +
        '<div class="hb-step-sub">1 bis ' + CONFIG.maxSorten + ' winterharte Fargesia-Sorten – für eine einheitliche oder gemischte Hecke.</div>' +
        '<div class="hb-sorten">' + sortenHtml + '</div></div>' +
 
        '<div class="hb-card"><div class="hb-step-label">Schritt 2</div>' +
        '<div class="hb-step-title">Maße deiner Hecke</div>' +
        '<div class="hb-step-sub">Wir berechnen daraus Pflanzenmenge und Kosten.</div>' +
        '<div class="hb-inputs">' +
        '<div class="hb-field"><label for="hb-laenge">Heckenlänge in Metern</label>' +
        '<input id="hb-laenge" type="number" min="0.5" step="0.5" inputmode="decimal" placeholder="z. B. 6" value="' + esc(state.laenge) + '">' +
        '<div class="hb-hint">Gesamtlänge der geplanten Hecke</div></div>' +
        '<div class="hb-field"><label for="hb-hoehe">Wunschhöhe in cm (optional)</label>' +
        '<input id="hb-hoehe" type="number" min="50" step="10" inputmode="numeric" placeholder="z. B. 250" value="' + esc(state.hoehe) + '">' +
        '<div class="hb-hint">Sorten unterhalb der Wunschhöhe werden ausgegraut</div></div>' +
        '<div class="hb-field"><label for="hb-dichte">Pflanzdichte</label>' +
        '<select id="hb-dichte">' +
        '<option value="normal"' + (state.dichte === 'normal' ? ' selected' : '') + '>Sichtschutz – z. B. 2 Pflanzen/m im 3-L-Topf</option>' +
        '<option value="fast"' + (state.dichte === 'fast' ? ' selected' : '') + '>Schneller Sichtschutz – z. B. 3 Pflanzen/m im 3-L-Topf</option>' +
        '</select>' +
        '<div class="hb-hint">Dichter gepflanzt wird die Hecke schneller blickdicht</div></div>' +
        '</div></div>' +
 
        (state.selected.length ?
          '<div class="hb-card"><div class="hb-step-label">Schritt 3</div>' +
          '<div class="hb-step-title">Topfgröße wählen</div>' +
          '<div class="hb-step-sub">Größere Töpfe = schnellerer Sichtschutz, kleinere = günstiger (mehr Pflanzen pro Meter).</div>' +
          variantHtml + '</div>' : '') +
 
        '<div class="hb-card"><div class="hb-step-label">Ergebnis</div>' +
        '<div class="hb-step-title">Deine Bambushecke</div>' + resultHtml + '</div>' +
 
        '<div class="hb-footer">Familienbetrieb seit 1984 · 3 Monate Anwuchsgarantie · <a href="' + esc(collectionUrl) + '">Alle Fargesia ansehen</a></div>';
 
      bind();
    }
 
    function bind() {
      Array.prototype.forEach.call(root.querySelectorAll('.hb-sorte'), function (el) {
        el.addEventListener('click', function () {
          var h = el.getAttribute('data-handle');
          var p = productByHandle(h);
          if (!p || !p.available) return;
          var idx = state.selected.indexOf(h);
          if (idx !== -1) state.selected.splice(idx, 1);
          else {
            if (state.selected.length >= CONFIG.maxSorten) state.selected.shift();
            state.selected.push(h);
          }
          render();
        });
      });
      var l = document.getElementById('hb-laenge');
      if (l) l.addEventListener('change', function () { state.laenge = l.value; render(); });
      var h = document.getElementById('hb-hoehe');
      if (h) h.addEventListener('change', function () { state.hoehe = h.value; render(); });
      var d = document.getElementById('hb-dichte');
      if (d) d.addEventListener('change', function () { state.dichte = d.value; render(); });
      Array.prototype.forEach.call(root.querySelectorAll('.hb-variant-row select'), function (sel) {
        sel.addEventListener('change', function () {
          state.variantByHandle[sel.getAttribute('data-handle')] = sel.value;
          render();
        });
      });
      var atc = document.getElementById('hb-atc');
      if (atc) atc.addEventListener('click', addToCart);
    }
 
    function addToCart() {
      var laenge = parseFloat(String(state.laenge).replace(',', '.'));
      var share = laenge / state.selected.length;
      var items = [];
      state.selected.forEach(function (hd) {
        var p = productByHandle(hd);
        var vid = state.variantByHandle[hd];
        var v = null;
        for (var i = 0; i < p.variants.length; i++) if (String(p.variants[i].id) === String(vid)) { v = p.variants[i]; break; }
        if (!v) return;
        items.push({ id: v.id, quantity: Math.max(1, Math.ceil(share * plantsPerMeter(v.title, state.dichte))) });
      });
      var msg = document.getElementById('hb-msg');
      var btn = document.getElementById('hb-atc');
      btn.disabled = true; btn.textContent = 'Wird hinzugefügt …';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) throw new Error('cart');
        msg.innerHTML = '<div class="hb-success">Hinzugefügt! Du wirst zum Warenkorb weitergeleitet …</div>';
        setTimeout(function () { window.location.href = CONFIG.checkoutPath; }, 800);
      }).catch(function () {
        btn.disabled = false; btn.textContent = 'Alles in den Warenkorb';
        msg.innerHTML = '<div class="hb-error">Das hat leider nicht geklappt. Bitte versuch es noch einmal.</div>';
      });
    }
 
    render();
  }
 
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();